import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';
import { TranslateModule } from '@ngx-translate/core';

import { MenuPanelComponent } from './menu-panel.component';

@NgModule({
  declarations: [MenuPanelComponent],
  imports: [CommonModule, OverlayModule, TranslateModule],
  exports: [MenuPanelComponent],
})
export class MenuPanelModule { }
